import store from '../store/index'
//------------------
// get pending slot
//------------------
export default function getFirstPendingSlot(combatant, selected_slot) {
  console.log('-----------------------------------')
  console.log('IN getFirstPendingSlot')
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat
  let maxCA = this_store.config.max_ca
  const currentActionNumber = Number(this_store.current_action_number || 0)
  const maxSelectableCA =
    selected_slot?.future === false && currentActionNumber > 0 ? currentActionNumber : maxCA
  // console.log("selected_slot.name = " + selected_slot.name);
  //----------------------
  // loop possible max ca
  //----------------------
  for (let k = 1; k <= maxSelectableCA; k++) {
    let ca_name = 'ca_name' + k
    let ca_type = 'ca_type' + k
    // console.log(
    //   "loop k = " +
    //     k +
    //     " ca_name = " +
    //     combatant[ca_name] +
    //     " ca_type = " +
    //     combatant[ca_type]
    // );
    //-------------------------------------------------------------------
    // return available ca where:
    // a) ca name = pending OR  ....... delay OR??
    // b) type = marker (not counter)
    // c) type = marker + cur name = counter + new name = remove_counter
    //-------------------------------------------------------------------
    if (
      combatant[ca_name] == 'pending' ||
      (combatant[ca_type] == '' && combatant[ca_name] == 'blank' && selected_slot.name == 'move') ||
      (combatant[ca_type] == 'marker' && combatant[ca_name] != 'counter') ||
      (combatant[ca_type] == 'marker' &&
        combatant[ca_name] == 'counter' &&
        selected_slot.name == 'remove_counter')
    ) {
      // console.log("first slot available = " + k);
      return k
    }
  }
}
